import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        paddingTop: 0
    },
    contentContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    iconContent:{
        justifyContent: "center",
        alignItems: "center",
        height: 55,
        width: 55
    },
    infoContent:{
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    infoItemContent: {
        justifyContent: "center"
    },
    textWrapper: {
        justifyContent: "center"
    },
    infoCardContainer: {
        flexDirection: "row"
    },
    checkboxContainer: {
        flexDirection: "row"
    },
    dialogHeader: {
        alignContent: "center",
        alignItems: "center"
    },
    successIconContainer: {
        alignSelf: "center"
    },
    submitButton: {
        height: 56
    }
});
export default stylesheet;
